import { Link } from "react-router-dom";

export default function ServiceHero() {
  return (
    <section className="relative w-full overflow-hidden" style={{ height: "78vh", minHeight: "600px" }}>
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/e361e5ed6cc7a4c0d397052a5305d6b7.jpg"
          alt="Precious Keepsakes Photography Services — San Antonio luxury portrait studio"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/30 to-black/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-8">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 mb-6 text-white/40 font-sans text-xs tracking-widest uppercase">
          <Link to="/" className="hover:text-pk-gold transition-colors cursor-pointer">Home</Link>
          <span className="text-white/25">/</span>
          <span className="text-pk-gold">Services</span>
        </nav>

        <div className="flex items-center gap-4 mb-5">
          <div className="w-10 h-px bg-pk-gold/70" />
          <span className="font-sans text-xs tracking-widest3 uppercase text-pk-gold">Investment</span>
          <div className="w-10 h-px bg-pk-gold/70" />
        </div>

        <h1 className="font-display text-7xl md:text-8xl font-light text-white leading-tight max-w-4xl">
          Photography <em className="font-medium text-pk-gold">Sessions</em>
        </h1>
        <p className="font-sans text-base text-white/65 mt-6 max-w-xl leading-8">
          Bespoke experiences crafted for the most meaningful chapters of your life —
          guided by Stephanie with 15+ years of fine art expertise.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center gap-5">
          <a
            href="#inquire"
            className="bg-pk-gold text-white font-sans text-xs tracking-widest3 uppercase px-12 py-5 rounded-sm hover:bg-white hover:text-pk-charcoal transition-colors duration-400 whitespace-nowrap cursor-pointer"
          >
            Begin Your Session
          </a>
          <a
            href="tel:2108154698"
            className="flex items-center gap-3 font-sans text-sm text-white/65 hover:text-pk-gold transition-colors duration-300 whitespace-nowrap cursor-pointer group"
          >
            <span className="w-8 h-8 flex items-center justify-center border border-white/20 rounded-full group-hover:border-pk-gold transition-colors duration-300">
              <i className="ri-phone-line text-xs" />
            </span>
            210-815-4698
          </a>
        </div>
      </div>
    </section>
  );
}
